import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router';

import CustomInput from '../../generic/CustomInput';
import CustomBtn from '../../generic/CustomBtn';
import CustomCheckbox from '../../generic/CustomCheckbox';
import CustomTextarea from '../../generic/CustomTextarea';
import DropzoneInput from '../../components/Dropzone/DropzoneInput';
import Loader from '../../components/Loader';
import RequestModal from '../../components/RequestModal';
import UpdatedMap from './UpdatedMap';
import { CoverPhotoInput, CoverPhotoPreview } from '../../components/WizardForm/Steps/GenInformation/CoverPhoto';
import Tooltip from '../../components/Tooltip';

import { ReactComponent as TooltipIcon } from '../../assets/image/carbon/circle-exclamation.svg';

import { appStore } from '../../state/app';
import { GAS } from '../../state/near';
import {
  getContract, contractMethods, getTxOutcome, isWalletCancelError,
} from '../../utils/near-utils';
import {
  FAILED_STATUS,
  ACTIVE_STATUS,
  projectTypes,
  REGISTER_STATUS,
  TERMINATED_STATUS,
} from '../../constans/constans';
import {
  buildGatewayUrl, getFilesFromDirWithContent, initIPFS,
} from '../../state/ipfs';
import {
  convertDurationWithMetrics,
  getProjectReference,
  milliToNano,
} from '../../utils/helpers';
import getProject from '../../services/getProject';
import getConfig from '../../config';
import { CustomReactSelect } from '../../generic/CustomSelect/CustomSelect';
import { CustomStyles } from '../../generic/CustomSelect/CustomeStyles';
import { chooseReUpdateData } from '../../utils/api-request';

const { deposit, projectDurationType } = getConfig();

const EditPage = () => {
  const history = useHistory();
  const { nameId } = useParams();
  const translate = useIntl();
  const { state } = useContext(appStore);
  const { account } = state;
  const [radioButtons, setRadioButtons] = useState(projectTypes(translate));
  // this states for edit inputs and fields
  const [initState, setInitState] = useState({});
  const { errors, register, handleSubmit, control } = useForm();
  const [startDate, setStartDate] = useState(new Date());
  const [loadingData, setLoading] = useState(true);
  const [iconCid, setIconCid] = useState({
    iconCidDir: '',
    secondIconCidDir: '',
  });
  const [durationOptions, setDurationOptions] = useState(new Array(100).fill('').map((el, index) => ({ label: index + 1, value: index + 1 })));
  const [valueDate, setValueDate] = useState({
    value: '',
    label: '',
    changed: false,
    previousValue: '',
  });
  const [statusProject, setStatusProject] = useState('');
  const [isDisabledBtn] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [filesCid, setFilesCid] = useState({ filesCidDir: '' });
  const [showModal, setShowModal] = useState({ show: false, type: '' });
  const [filesList, setFilesList] = useState([]);
  const [,setRequestError] = useState(false);
  const [lastStageEndTime, setLastStageEndTime] = useState(0);
  const [showResizedPhoto, setShowResizedPhoto] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [resizedImage, setResizedImage] = useState({
    largeCoverPhotoBlob: {},
    largeCoverPhotoUrl: '',
    largeCoverLoader: true,
    smallCoverPhotoBlob: {},
    smallCoverPhotoUrl: '',
    smallCoverLoader: true,
  });
  const isCarbonApplicationExist = !!initState.carbonApplication;
  const currentDate = Date.now() * 1e6;

  const onRadioChange = (val) => {
    const value = val;
    const newRadioButtons = [...radioButtons];
    newRadioButtons.forEach((item) => {
      item.checked = item.value === value;
    });
    setRadioButtons(newRadioButtons);
  };

  const getIcon = async (hash, signal) => {
    try {
      if (hash) {
        const ipfs = await initIPFS();
        const res = await getFilesFromDirWithContent(ipfs, hash, signal);
        if (res && res[0]?.content) {
          const blobImage = new Blob(res[0].content);
          const imageUrl = URL.createObjectURL(blobImage);
          setResizedImage({
            ...resizedImage,
            smallCoverPhotoUrl: imageUrl,
          });
          setIconCid({ secondIconCidDir: hash });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getFilesList = async (hash, signal) => {
    try {
      const ipfs = await initIPFS();
      const updateArray = await getFilesFromDirWithContent(ipfs, hash, signal);
      setFilesList(updateArray.map((el) => {
        const convertedFile = new File([el.content], el.path);
        // Additional helper field
        convertedFile.path = el.path;
        return convertedFile;
      }));
      setFilesCid({ filesCidDir: hash });
    } catch (e) {
      console.log(e);
    }
  };

  const changeData = async (dataProject, signal) => {
    const { type, status, startTimeProject, projectDuration, secondIconCidDir, iconCidDir, filesCidDir } = dataProject;
    setStatusProject(status?.toLowerCase());
    setInitState({ ...dataProject });
    onRadioChange(type);

    if (filesCidDir) await getFilesList(filesCidDir, signal);
    await getIcon(secondIconCidDir || iconCidDir, signal);

    if (status && status !== REGISTER_STATUS) {
      const xmas = new Date((startTimeProject / 1000000));
      const fullYear = xmas.getFullYear();
      setStartDate(xmas.getFullYear());
      const durationYears = fullYear + (+dataProject.projectDuration || 1);
      const durationOptionsYears = new Array(100).fill('').map((el, index) => ({ label: index + durationYears, value: index + durationYears }));
      setDurationOptions(durationOptionsYears);
      setValueDate({
        ...valueDate,
        value: ((+projectDuration) + fullYear).toString(),
        label: ((+projectDuration) + fullYear).toString(),
        previousValue: ((+projectDuration) + fullYear).toString(),
      });
    }
  };

  const calcAdditionalDuration = (newValue, prevValue) => {
    const delta = newValue - prevValue;
    const duration = convertDurationWithMetrics(delta, projectDurationType);
    return milliToNano(duration).toString();
  };

  const getDuration = (dateObj, status) => {
    const {
      changed, // true, if end year of project has been changed
      value: endOfProject, // new end year of project
      previousValue: prevEndOfProject, // old end year of project
      projectDuration, // project duration (counted in years or days); only for REGISTER_STATUS
    } = dateObj;

    if (status === REGISTER_STATUS) {
      return {
        duration: projectDuration.toString(),
        additionalDuration: null,
      };
    }

    if (status === ACTIVE_STATUS) {
      const newDuration = (endOfProject - startDate).toString();
      const oldDuration = (prevEndOfProject - startDate).toString();
      return {
        duration: changed ? newDuration : oldDuration,
        additionalDuration: changed ? calcAdditionalDuration(endOfProject, prevEndOfProject) : null,
      };
    }
  };

  const handleMintUpdate = async (dataProject) => {
    try {
      if (statusProject === REGISTER_STATUS || statusProject === ACTIVE_STATUS) {
        const ipfs = await initIPFS();
        const { project_id: projectId, projectDuration, name, iconCidDir, type } = dataProject;
        const { duration, additionalDuration } = getDuration({ ...valueDate, projectDuration }, statusProject);
        const { path } = await ipfs.add(JSON.stringify({ ...dataProject, projectDuration: duration }));

        const contract = getContract(account, contractMethods, 0);
        const prevReference = await getProjectReference(contract, projectId);

        if (path && prevReference) {
          const txResult = await contract.update_project_metadata({
            project_id: projectId,
            project_type: type,
            title: name,
            media: buildGatewayUrl(iconCidDir),
            reference: `/ipfs/${path}`,
            prev_reference: prevReference,
            additional_duration: additionalDuration,
          }, GAS, deposit);
          const { isSuccess, methodName } = getTxOutcome(txResult);
          if (!isSuccess || methodName !== 'update_project_metadata') {
            throw new Error('update_project_metadata tx was not successful');
          }
          setShowModal({
            show: true,
            type: '',
          });
        } else throw new Error();
      }
    } catch (e) {
      if (isWalletCancelError(e)) {
        return;
      }
      setRequestError(true);
      setShowModal({ show: true, type: '' });
    }
  };

  const updateInitState = async (newData) => {
    const copyData = { ...newData, avgTrees: newData.avgTrees };
    const updData = { ...copyData };
    const reUpdateDate = await chooseReUpdateData(initState.project_id, account, { ...initState });
    let newInitState = { ...reUpdateDate, ...updData };

    if ((iconCid.iconCidDir || iconCid.secondIconCidDir) !== (initState.iconCidDir || initState.secondIconCidDir)) {
      newInitState = { ...newInitState, ...iconCid };
    }

    if (filesCid.filesCidDir !== initState.filesCidDir) {
      newInitState = { ...newInitState, ...filesCid };
    }

    setInitState({ ...newInitState });
    await handleMintUpdate({ ...newInitState, avgTrees: +((`${newInitState.avgTrees}`).split(',').join('')) });
  };

  const onSubmit = async (updtData) => {
    const updData = {
      ...updtData,
      projectDuration: updtData.projectDuration?.value.toString(),
    };

    try {
      setLoading(true);
      await updateInitState(updData);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      if (isWalletCancelError(e)) {
        return;
      }
      setRequestError(true);
      setShowModal({
        show: true,
        type: '',
      });
    }
  };

  const handleBadIpfs = () => {
    setRequestError(true);
    setShowModal({
      show: true,
      type: '',
    });
  };

  const handleChangeEndDate = (e) => {
    if (+e === valueDate.previousValue) {
      setValueDate({
        ...valueDate,
        value: e.toString(),
        label: e.toString(),
        changed: false,
      });
    } else {
      setValueDate({
        ...valueDate,
        value: e.toString(),
        label: e.toString(),
        changed: true,
      });
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (account) {
      (async () => {
        const bodyReq = {
          query: {
            bool: {
              must: [
                {
                  match: {
                    'project_id.keyword': nameId,
                  },
                },
                {
                  match: {
                    'signer_id.keyword': account.accountId,
                  },
                },
              ],
            },
          },
        };
        if (nameId) {
          const dataProject = await getProject(bodyReq);
          const tokenData = dataProject.data?.hits?.hits?.length && dataProject.data?.hits?.hits[0]._source;
          if (tokenData) {
            if (tokenData.stages?.length) setLastStageEndTime(tokenData.stages[tokenData.stages.length - 1].ends_at);
            await changeData(tokenData, signal);
          }
        }
        setLoading(false);
      })();
    }

    return () => {
      controller.abort();
    };
  }, [account]);

  const projectDurationLabel = `${translate.formatMessage({
    id: projectDurationType === 'year'
      ? 'wizardForm.step1.expectedProjectDuration'
      : 'wizardForm.step1.expectedProjectDuration-days',
  })}`;

  const projectDuration = initState?.projectDuration;

  const defaultValue = projectDuration ? {
    value: `${projectDuration}`,
    label: `${projectDuration}`,
  } : null;

  if (loadingData) {
    return (
      <div className="dashboard__loader all-window"><Loader /></div>
    );
  }

  // If last stage is finished
  if (lastStageEndTime > 0 && lastStageEndTime < currentDate) {
    return (
      <RequestModal
        handleClose={() => history.push('/')}
        title={translate.formatMessage({ id: 'modal.title.congratulations' })}
        description={translate.formatMessage({ id: 'modal.description.finished' })}
      />
    );
  }

  if (!statusProject) {
    return (
      <RequestModal
        error
        handleClose={() => history.push('/')}
        title={translate.formatMessage({ id: 'modal.title.wentWrong' })}
        description={translate.formatMessage({ id: 'modal.description.canNotTrack' })}
        buttonText={translate.formatMessage({ id: 'modal.button.return' })}
      />
    );
  }

  if (statusProject?.toLowerCase() === FAILED_STATUS
    || statusProject?.toLowerCase() === TERMINATED_STATUS) {
    return (
      <RequestModal
        error
        handleClose={() => history.push('/')}
        title={<span>{translate.formatMessage({ id: 'modal.title.denied' })}</span>}
        description={(
          <p className="text-inner-color">
            <FormattedMessage
              id="modal.description.canNot"
              values={{
                br: <br />,
                link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
              }}
            />
          </p>
        )}
        buttonText={translate.formatMessage({ id: 'modal.button.return' })}
        buttonClass="btn__request-den"
      />
    );
  }

  return (
    <div className="preview">
      {showResizedPhoto ? (
        <>
          <CoverPhotoPreview
            showResizedPhoto={showResizedPhoto}
            setShowResizedPhoto={setShowResizedPhoto}
            resizedImage={resizedImage}
            setResizedImage={setResizedImage}
            setIconCid={setIconCid}
          />
        </>
      ) : null }
      {showModal.show && (
        <RequestModal
          error={showModal.type}
          handleClose={() => setShowModal({ show: false, type: '' })}
          title={showModal.type ? translate.formatMessage({ id: 'modal.title.oops' }) : translate.formatMessage({ id: 'modal.title.success' })}
          description={showModal.type ? (
            <FormattedMessage
              id="modal.description.somethingGoesWrong"
              values={{
                link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="text-anchor">{chunks}</a>,
              }}
            />
          ) : translate.formatMessage({ id: 'modal.description.projectInformationUpdated' })}
        />
      )}
      <form className="preview__gen" onSubmit={handleSubmit(onSubmit)}>
        <div className="preview__block">
          <h3 className="preview__block-title">
            {translate.formatMessage({ id: 'wizardForm.step1.generalInformation' })}
          </h3>
          <div className="preview__block-wrapper">
            <div className="preview__gridBox">
              <div className="preview__flexBox">
                <span className="preview__inputLabel">
                  {translate.formatMessage({ id: 'wizardForm.step1.organizationName' })}
                </span>
                <CustomInput
                  type="text"
                  placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
                  register={register({
                    required: translate.formatMessage({ id: 'wizardForm.required' }),
                    maxLength: 1000,
                  })}
                  required
                  error={errors.developer}
                  value={initState.developer}
                  name="developer"
                  customClass="preview__input"
                />
              </div>
              <div className="preview__flexBox">
                <span className="preview__inputLabel">
                  {translate.formatMessage({ id: 'wizardForm.step1.projectName' })}
                </span>
                <CustomInput
                  type="text"
                  placeholder={translate.formatMessage({ id: 'wizardForm.step1.projectName-placeholder' })}
                  register={register({
                    required: translate.formatMessage({ id: 'wizardForm.required' }),
                    maxLength: 1000,
                  })}
                  required
                  change={() => { }}
                  error={errors.name}
                  value={initState.name}
                  name="name"
                  customClass="preview__input"
                />
              </div>
            </div>
            <div className="preview__gridBox duration ">
              <div className="preview__flexBox">
                <span className="preview__inputLabel">
                  {projectDurationLabel}
                </span>
                {statusProject !== 'register'
                  ? (
                    <div className="preview__gridBox-half">
                      <CustomInput
                        type="number"
                        placeholder={translate.formatMessage({ id: 'wizardForm.step1.projectDate-placeholder' })}
                        required
                        disabled
                        change={() => { }}
                        value={startDate}
                        name="startDate"
                        customClass="preview__input duration-input"
                      />
                      <CustomReactSelect
                        selectOnChange={handleChangeEndDate}
                        control={control}
                        options={durationOptions}
                        defaultValue={valueDate}
                        rules={{ required: true }}
                        isClearable={false}
                        error={errors?.projectDuration}
                        name="projectDuration"
                        titleClass="generalInformation__input-label"
                        wrapperClass="generalInformation__projectDuration duration-selector"
                        selectStyles={CustomStyles(errors)}
                      />
                    </div>
                  ) : (
                    <CustomReactSelect
                      control={control}
                      placeholder={translate.formatMessage({ id: 'wizardForm.step1.expectedProjectDuration-placeholder' })}
                      options={durationOptions}
                      defaultValue={defaultValue}
                      rules={{ required: true }}
                      isClearable={false}
                      error={errors?.projectDuration}
                      name="projectDuration"
                      titleClass="generalInformation__input-label"
                      wrapperClass="generalInformation__projectDuration duration-selector"
                      selectStyles={CustomStyles(errors)}
                    />
                  )}
              </div>

            </div>
            <div className="preview__projectTypeBlock">
              <div className="preview__flexBox">
                <div className="preview__inputLabel">
                  <span>{translate.formatMessage({ id: 'wizardForm.step1.projectType' })}</span>
                  {isCarbonApplicationExist && (
                    <Tooltip
                      wrapperClass="tooltip"
                      targetElement={<TooltipIcon data-tip data-iscapture data-for="project-type" />}
                      tooltipElement={translate.formatMessage({ id: 'wizardForm.tooltip.projectType' })}
                      tooltipProps={{ className: 'tooltip__message', id: 'project-type' }}
                    />
                  )}
                </div>
                {errors.type && <span className="preview__textError">{translate.formatMessage({ id: 'wizardForm.step1.projectType-warning' })}</span>}
                {radioButtons.map(({ value, title, description, checked }) => (
                  <CustomCheckbox
                    type="radio"
                    onChange={() => onRadioChange(value)}
                    value={value}
                    title={translate.formatMessage({ id: title })}
                    description={translate.formatMessage({ id: description })}
                    register={register({
                      required: true,
                    })}
                    name="type"
                    checked={checked}
                    disabled={isCarbonApplicationExist}
                    key={value}
                  />
                ))}
              </div>
            </div>
            <div className="preview__gridBox-half">
              <div className="preview__flexBox">
                <div className="preview__flexBox">
                  <span className="preview__inputLabel">
                    {translate.formatMessage({ id: 'wizardForm.step3.projectDocumentation' }) }
                  </span>
                  <span className="preview__documents-warning-text">
                    {translate.formatMessage({ id: 'wizardForm.step3.projectDocumentation-warning' }) }
                  </span>
                </div>
                <div className="preview__flexBox">
                  <DropzoneInput
                    change={setFilesCid}
                    multipleFiles
                    amountFiles={10}
                    droppedFiles={filesList}
                    setDroppedFiles={setFilesList}
                    previewCustomClass="wizard__doc-dropzone"
                    handleBadIpfs={handleBadIpfs}
                  />
                </div>
              </div>
              <div className="preview__flexBox">
                <span className="preview__inputLabel">
                  {translate.formatMessage({ id: 'wizardForm.step1.coverPhoto' })}
                </span>
                <span className={!errorMsg ? 'preview__textInfo' : 'preview__textError'}>
                  {translate.formatMessage({ id: 'wizardForm.step1.coverPhoto-warning' })}
                </span>
                {!resizedImage?.smallCoverPhotoUrl && <span className={'preview__textError'}>
                  {translate.formatMessage({ id: 'wizardForm.step1.coverPhoto-warning1' })}
                </span>}
                <CoverPhotoInput
                  showResizedPhoto={showResizedPhoto}
                  setShowResizedPhoto={setShowResizedPhoto}
                  resizedImage={resizedImage}
                  setResizedImage={setResizedImage}
                  setErrorMsg={setErrorMsg}
                />
              </div>
            </div>
          </div>
        </div>
        {statusProject === 'register' && (
          <div className="preview__block">
            <h3 className="preview__block-title">
              {translate.formatMessage({ id: 'projectView.location' })}
            </h3>
            <div className="preview__block-wrapper">
              <UpdatedMap initState={initState} setInitState={setInitState} />
            </div>
          </div>
        )}
        <div className="preview__block">
          <h3 className="preview__block-title">
            {translate.formatMessage({ id: 'wizardForm.step3.additionalInformation' })}
          </h3>
          <div className="preview__block-wrapper">
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.projectDescription' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.input-placeholder-type-here' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 1000,
              })}
              required
              error={errors.aboutProject}
              value={initState.aboutProject}
              name="aboutProject"
              customClassLabel="preview__textAreaBlock-label"
              customClass="preview__textAreaBlock"
              classTextarea="preview__textAreaBlock-body"
              rows={5}
            />
            <CustomTextarea
              label={translate.formatMessage({ id: 'wizardForm.step3.projectGoals' })}
              placeholder={translate.formatMessage({ id: 'wizardForm.step3.projectGoals' })}
              register={register({
                required: translate.formatMessage({ id: 'wizardForm.required' }),
                maxLength: 1000,
              })}
              required
              error={errors.goals}
              value={initState.goals}
              name="goals"
              customClassLabel="preview__textAreaBlock-label"
              customClass="preview__textAreaBlock"
              classTextarea="preview__textAreaBlock-body"
              rows={5}
            />
            <div className="preview__gridBox">
              <CustomTextarea
                label={translate.formatMessage({ id: 'wizardForm.step3.stakeholders' })}
                placeholder={translate.formatMessage({ id: 'wizardForm.step3.stakeholders' })}
                register={register({
                  required: translate.formatMessage({ id: 'wizardForm.required' }),
                  maxLength: 1000,
                })}
                required
                error={errors.masters}
                value={initState.masters}
                name="masters"
                customClassLabel="preview__textAreaBlock-labelDouble"
                customClass="preview__textAreaBlock"
                classTextarea="preview__textAreaBlock-body"
                rows={5}
              />
              <CustomTextarea
                label={translate.formatMessage({ id: 'wizardForm.step3.coBenefits' })}
                placeholder={translate.formatMessage({ id: 'wizardForm.step3.coBenefits' })}
                register={register({
                  required: translate.formatMessage({ id: 'wizardForm.required' }),
                  maxLength: 1000,
                })}
                required
                error={errors.benefits}
                value={initState.benefits}
                name="benefits"
                customClassLabel="preview__textAreaBlock-labelDouble"
                customClass="preview__textAreaBlock"
                classTextarea="preview__textAreaBlock-body"
                rows={5}
              />
            </div>
            <div className="preview__gridBox">
              <CustomInput
                label={translate.formatMessage({ id: 'wizardForm.step3.averageTreeDensity' })}
                control={control}
                rules={{
                  required: true,
                  validate: {
                    leadingZeros: (value) => +value[0] !== 0 || translate.formatMessage({ id: 'wizardForm.step3.invalidValue' }),
                    lessThan: (value) => value.toString().split(',').join('') < 100000 || translate.formatMessage({ id: 'wizardForm.step3.thisFieldIsTooBig' }),
                  },
                }}
                placeholder={translate.formatMessage({ id: 'wizardForm.step3.averageTreeDensity' })}
                error={errors.avgTrees}
                value={initState.avgTrees}
                name="avgTrees"
                useNumberFormat
                numberFormatParams={{ allowNegative: false, thousandSeparator: true, decimalScale: 0 }}
                required
                customClass="preview__input half"
                customClassLabel="preview__inputLabel inputLabelPosition"
              />
              <CustomTextarea
                label={translate.formatMessage({ id: 'wizardForm.step3.treeSpecies' })}
                placeholder={translate.formatMessage({ id: 'wizardForm.step3.treeSpecies' })}
                register={register({
                  required: translate.formatMessage({ id: 'wizardForm.required' }),
                  maxLength: 1000,
                })}
                required
                error={errors.treeSpecies}
                value={initState.treeSpecies}
                name="treeSpecies"
                customClassLabel="preview__textAreaBlock-label"
                customClass="preview__textAreaBlock"
                classTextarea="preview__textAreaBlock-body"
                rows={5}
              />
            </div>
            <div className="preview__gridBox-half">
              <CustomBtn
                label={translate.formatMessage({ id: 'button-back' })}
                handleClick={() => history.push(`/project/${nameId}`)}
                type="button"
                customClass="btn__cancel"
              />
              <CustomBtn
                disabled={isDisabledBtn}
                label={translate.formatMessage({ id: 'button-updateProject' })}
                type="submit"
                handleClick={() => { }}
                customClass={`btn__next ${isDisabledBtn ? 'btn__next-disabled' : ''}`}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditPage;
